import React, { FC, useState } from "react";

import { FilterMoreLessButton } from "../../../components";

const DesktopFilterButtonMoreLess: FC = () => {
  const [buttonClicked, setButtonClicked] = useState(false);
  const [showMoreOrLessTitle, setshowMoreOrLessTitle] = useState("More");

  const onButtonClick = () => {
    setButtonClicked(!buttonClicked);

    if (buttonClicked) {
      setshowMoreOrLessTitle("More");
    } else {
      setshowMoreOrLessTitle("Less");
    }
  };

  return (
    <FilterMoreLessButton
      type="button"
      title={showMoreOrLessTitle}
      onClick={onButtonClick}
    />
  );
};

export default DesktopFilterButtonMoreLess;
